//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

//  emit WithdrawRequested(owner, assets, shares);
import * as yup from 'yup'
import { InferType } from 'yup'
import { yupEthAddrRequired } from './Enums'
import { EthAddr, StringTypeEnum, toFieldMetaData } from './SchemaTypes'

export enum TransferStepNames {
  Source_Approval_Pending = 'Source Approval Pending',
  Source_Approved = 'Source Approved',
  Destination_Approval_Pending = 'Destination Approval Pending',
  Destination_Approved = 'Destination Approved',
  Source_Burn_Pending = 'Source Burn Pending',
  Source_Burned = 'Source Burned',
  Destination_Mint_Pending = 'Destination Mint Pending',
  Destination_Minted = 'Destination Minted',
}
export enum TransferStepNumbers {
  Source_Approval_Pending = 0,
  Source_Approved = 1,
  Destination_Approval_Pending = 2,
  Destination_Approved = 3,
  Source_Burn_Pending = 4,
  Source_Burned = 5,
  Destination_Mint_Pending = 6,
  Destination_Minted = 7,
}

export const TransferStepToString: Record<number, string> = {
  0: TransferStepNames.Source_Approval_Pending,
  1: TransferStepNames.Source_Approved,
  2: TransferStepNames.Destination_Approval_Pending,
  3: TransferStepNames.Destination_Approved,
  4: TransferStepNames.Source_Burn_Pending,
  5: TransferStepNames.Source_Burned,
  6: TransferStepNames.Destination_Mint_Pending,
  7: TransferStepNames.Destination_Minted,
}
export const PoolCrossChainTransferSchema = yup.object({
  poolAddr: yupEthAddrRequired
    .required()
    .label('PoolAddr For target Chain')
    .meta(toFieldMetaData({ propName: 'poolAddr' })),
  sourcePoolAddr: yupEthAddrRequired
    .required()
    .label('Source Pool Address')
    .meta(toFieldMetaData({ propName: 'sourcePoolAddr' })),

  timestamp: yup
    .number()
    .required()
    .label('Offchain Data Timestamp')
    .meta(toFieldMetaData({ propName: 'timestamp', stringType: StringTypeEnum.UNIX_DATE })),

  sourceChainId: yup
    .number()
    .required()
    .label('Source Chain Id')
    .meta(toFieldMetaData({ propName: 'sourceChainId' })),
  sourceDeploymentName: yup
    .string()
    .required()
    .label('Source Deployment Name')
    .meta(toFieldMetaData({ propName: 'sourceDeploymentName' })),

  sourceWalletAddr: yupEthAddrRequired
    .required()
    .label('Source Wallet Address')
    .meta(toFieldMetaData({ propName: 'sourceWalletAddr' })),

  destinationPoolAddr: yupEthAddrRequired //
    .required()
    .label('Destination Pool Address')
    .meta(toFieldMetaData({ propName: 'destinationPoolAddr' })),

  destinationChainId: yup
    .number()
    .required()
    .label('Destination Chain Id')
    .meta(toFieldMetaData({ propName: 'destinationChainId' })),
  destinationDeploymentName: yup
    .string()
    .required()
    .label('Destination Deployment Name')
    .meta(toFieldMetaData({ propName: 'destinationDeploymentName' })),

  destinationWalletAddr: yupEthAddrRequired //
    .required()
    .label('Destination Wallet Address')
    .meta(toFieldMetaData({ propName: 'destinationWalletAddr' })),

  amount: yup
    .number()
    .required()
    .label('Target Amount')
    .meta(toFieldMetaData({ propName: 'amount' })),
  transferStep: yup
    .number()
    .label('Transfer Step')
    .required()
    .meta(
      toFieldMetaData({ propName: 'transferStep', description: 'Transfer Step ', stateToString: TransferStepToString })
    ),
  transferStepName: yup
    .string()
    .label('Transfer Step Name')
    .required()
    .meta(
      toFieldMetaData({
        propName: 'transferStepName',
        description: 'Transfer Step Name',
      })
    ),
})

export interface PoolCrossChainTransferCTO extends InferType<typeof PoolCrossChainTransferSchema> {
  poolAddr: EthAddr
  sourcePoolAddr: EthAddr
  destinationPoolAddr: EthAddr
}
